import { create } from 'zustand';

export type SelectionKind = 'planet' | 'small_body' | 'p9_sample';

export interface Selection {
  kind: SelectionKind;
  id: string;       // ID Horizons pour planètes, key pour small_body, sample_id stringifié pour p9
  name: string;
}

interface SelectionState {
  current: Selection | null;
  select: (s: Selection) => void;
  clear: () => void;
}

export const useSelection = create<SelectionState>((set) => ({
  current: null,
  select: (s) => set({ current: s }),
  clear: () => set({ current: null }),
}));
